export default function getCurrentURL() {
  return new URL(window.location.href)
}
